<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  name: 'App',
  components: {},
  created() {
    this.loadStatuses();
  },
  mounted() {
    this.checkUser();
  },
  methods: {
    ...mapActions('statuses', ['loadStatuses']),
    ...mapMutations('user', ['SET_USER']),

    checkUser() {
      if (this.$storage.get('user-info')) {
        this.SET_USER(this.$storage.get('user-info'));
      }
    },
  }
};
</script>

<style lang="sass">
  @import '@/styles/app'
</style>
